import { $color } from "@/utils/cssVarUtils"
import { keyframes } from "@chakra-ui/system"
import type { SystemStyleFunction } from "@chakra-ui/theme-tools"

const fade = () =>
  keyframes({
    from: {
      backgroundPosition: '100% 0',
    },
    to: {
      backgroundPosition: '0 0',
    },
  })

const baseStyle: SystemStyleFunction = (props) => {
  const defaultStartColor = $color('bg-input-normal')
  const defaultEndColor = 'transparent'

  const {
    startColor = defaultStartColor,
    endColor = defaultEndColor,
    speed,
  } = props

  const gradient = `linear-gradient(
    to right,
    ${endColor},
    ${startColor},
    ${endColor},
    ${startColor},
    ${endColor}
  )`

  return {
    opacity: 1,
    borderRadius: "4xs",
    borderColor: 'none',
    h: '2xs',
    backgroundSize: '200%',
    background: gradient,
    animation: `${speed}s linear infinite ${fade()}`,
  }
}

export const Skeleton = {
  baseStyle,
}